export default function Footer() {
  return (
    <footer className="text-gray-500  w-screen left-0 right-0 bg-white px-4 py-5  mx-auto md:px-8">
      <div className="max-w-lg sm:mx-auto sm:text-center">
        <div className="flex justify-center items-center">
          <img
            src="https://res.cloudinary.com/dv1fwnib8/image/upload/v1766038083/logo-final.png"
            width={140}
            className="mx-auto"
            alt="Thread Logo"
          />
          {/* change to thread logo */}
        </div>
        <p className="leading-relaxed mt-2 text-[15px]">
          Lorem Ipsum has been the industry's standard dummy text ever since the
          1500s, when an unknown printer took a galley of type and scrambled it
          to make a type specimen book.
        </p>
        <div className="pt-6 text-sm sm:mt-0">
          &copy; 2022 Float UI All rights reserved.
        </div>
      </div>
    </footer>
  );
}
